import trainEvents from '../config/train-events';

export default function TrainsHeaderBaseController(
    $scope,
    $state,
    $rootScope,
    trainsFactory,
    userService,
    l10nService,
    flightsUtils,
    timeService
) {
    'ngInject';

            /**
             * Localization settings
             */
            const regionalSettings = userService.getRegionalSettings();

            $scope.module = trainsFactory.getModule();
            $scope.isFlights = trainsFactory.isFlights();
            $scope.isTrains = trainsFactory.isTrains();
            $scope.labels = trainsFactory.getLabels();
            $scope.options = trainsFactory.options;
            $scope.params = trainsFactory.params;
            $scope.tempParams = angular.copy(trainsFactory.params);
            $scope.showFiltersFlight = true;
            // Format departure and return date
            const convertedDepartureDate = timeService.getDateInUserRegionFormatOrCurrentDate(
                $scope.params.TicketSearchSegments[0]._date
            );
            let convertedReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
                $scope.params.TicketSearchSegments[0]._date);

            if (flightsUtils.isRoundTripOrMultiTripFlight($scope.params.flightType)) {
                convertedReturnDate
                    = timeService.getDateInUserRegionFormat($scope.params.TicketSearchSegments[1]._date)
                        .format(regionalSettings.mediumDayMonthDateFormat);
            }

            $scope.flights = trainsFactory.getFlights();

            if (_.isEmpty($scope.flights)) {
                return $state.go('main.' + trainsFactory.getModule() + '.roundtrip');
            }

            /**
             * Set page Heading for mobile
             */
            initHeading();

            $scope.headerAll = {
                Total: $scope.flights.Total,
                FilteredTotal: $scope.flights.FilteredTotal,
                TotalPassengerCount: +$scope.params.Travelers.Adult.value + +$scope.params.Travelers.Infant.value + +$scope.params.Travelers.Child.value,
                convertedDepartureDate,
                convertedReturnDate,
                route: flightsUtils.calculateRoute($scope.params.TicketSearchSegments, $scope.params.flightType),
                dates: flightsUtils.calculateDates($scope.params.TicketSearchSegments, $scope.params.flightType),
            };

            const initialDepartDate = timeService.getDateInUserRegionFormatOrCurrentDate(
                $scope.params.TicketSearchSegments[0]._date);
            const initialReturnDate = timeService.getDateInUserRegionFormatOrCurrentDate(
                $scope.params.TicketSearchSegments[1]._date);

            $scope.dateOptions = {
                optionsDepart: {
                    placeholder: l10nService.localize('Depart date'),
                    required: true,
                    months: 2,
                    start: initialDepartDate,
                    after: moment().add({days: -1}),
                    before: trainsFactory.getMaxBookDate(),
                    dependentPikers: ['dateOptions.optionsReturn'],
                },
                optionsReturn: {
                    placeholder: l10nService.localize('Return date'),
                    required: true,
                    months: 2,
                    start: initialReturnDate,
                    before: trainsFactory.getMaxBookDate(),
                    after: moment(initialDepartDate).add({days: -1}),
                },
            };

            // Header is collapsed initially
            $scope.showHeader = true;

            /**
             * Restore form when header closed
             */
            $scope.$watch('showHeader', function(newValue) {
                if (newValue) {
                    $scope.tempParams = angular.copy($scope.params);
                    $scope.dateOptions.optionsReturn.after = moment(initialDepartDate).add({days: -1});
                }
            });

            /**
             * Reset return date if earlier then departure date
             */
            $scope.$watch('tempParams.TicketSearchSegments[0]._date', resetDateIfEarlierThanDeparture);
            $scope.$watch('flights.FilteredTotal', initHeading);

            $scope.edit = edit;
            $scope.toggleFiltersFlight = toggleFiltersFlight;
            $scope.findFlights = findFlights;

            function resetDateIfEarlierThanDeparture() {
                if ($scope.tempParams.flightType === 'roundtrip') {
                    const departDate = moment($scope.tempParams.TicketSearchSegments[0]._date, regionalSettings.dateFormat);
                    const returnDate = moment($scope.tempParams.TicketSearchSegments[1]._date, regionalSettings.dateFormat);
                    if (departDate.isAfter(returnDate)) {
                        $scope.dateOptions.optionsReturn.update('');
                    }
                }
            }

            /**
             * Perform search and go to results page
             */
            function findFlights() {
                trainsFactory.findFlights($scope.tempParams).then(function() {
                    $state.go($state.current, {}, {reload: true, inherit: false, notify: true});
                });
            }

            function toggleFiltersFlight() {
                $scope.showFiltersFlight = !$scope.showFiltersFlight;
                $rootScope.$broadcast(trainEvents.TRIGGER_FLIGHT_FILTERS);
            }

            /**
             * Toggle edit query form
             */
            function edit() {
                if (flightsUtils.isMultiTripFlight($scope.params.flightType)) {
                    $state.go('main.flights.multitrip');
                } else {
                    $scope.showHeader = !$scope.showHeader;
                }
            }

            function initHeading() {
                $rootScope.pageHeading = l10nService.localize('Flights') + ' (' + $scope.flights.FilteredTotal + ')';
            }

}



// WEBPACK FOOTER //
// ./src/app/modules/trains-base/controllers/trains-header-base-controller.js